module.exports = __webpack_public_path__ + "img/dce2cf8.jpg";